import { Item } from "dsabp-js"
import { rendererResolvers } from "../main.js"
import { getImage } from "../util.js"

// These items don't have buildInfo.image but use item.image as the only image name
// TODO: BULK_EJECTOR does not belong here

rendererResolvers.push(
	({ item }) => {
		if (![Item.NAV_UNIT, Item.TURRET_CONTROLLER_NEW, Item.BULK_BAY_MARKER, Item.BULK_EJECTOR].includes(item))
			return

		return {
			discriminator: `${item.id}`,
			async render() {
				return [{ image: await getImage(item.id == 264 ? "bulk_ejector" : item.image.substring("item/".length)) }]
			}
		}
	}
)
